import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
    apiVersion: "2017-11-27",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: defaultRegionInfoProvider,
    signingName: "comprehend",
};
//# sourceMappingURL=runtimeConfig.shared.js.map